import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase 콘솔 → 프로젝트 설정 → 내 앱 → SDK 설정 및 구성에서 복사
const firebaseConfig = {
    apiKey: "AIzaSyAQTCpVgsIBuOMKEwuIR3-XG331xFDI2aE",
    authDomain: "my-workout-journal-bb408.firebaseapp.com",
    projectId: "my-workout-journal-bb408",
    storageBucket: "my-workout-journal-bb408.firebasestorage.app",
    messagingSenderId: "152404380587",
    appId: "1:152404380587:web:e176795e961cc04eb1e0ee",
    measurementId: "G-3FF4P3M5HK"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
